import React from 'react';
import PropTypes from 'prop-types';

import Heading from 'components/shared/heading';
import Button from 'components/shared/button';
import styles from './styles.module.scss';

const SuccessMessage = ({
  title = '',
  description = '',
  supportTitle = '',
  email = '',
  phone = '',
  buttonLabel = '',
  buttonLink = '',
}) => (
  <div className={styles.successMessage}>
    <div className={styles.successIcon}>
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="32" cy="32" r="32" fill="#52C41A" fillOpacity="0.1" />
        <path
          d="M32 8C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8zm0 44c-11.046 0-20-8.954-20-20S20.954 12 32 12s20 8.954 20 20-8.954 20-20 20z"
          fill="#52C41A"
        />
        <path
          d="M28.586 38.586L22.414 32.414c-.781-.781-2.047-.781-2.828 0-.781.781-.781 2.047 0 2.828l7.5 7.5c.781.781 2.047.781 2.828 0l15-15c.781-.781.781-2.047 0-2.828-.781-.781-2.047-.781-2.828 0l-13.586 13.586z"
          fill="#52C41A"
        />
      </svg>
    </div>

    <Heading className={styles.title} tag="h3" size="lg">
      {title}
    </Heading>

    {description && (
      <div className={styles.message}>
        <p>{description}</p>
      </div>
    )}

    {(email || phone) && (
      <div className={styles.contactInfo}>
        {supportTitle && <p>{supportTitle}</p>}
        <div className={styles.contactLinks}>
          {email && <a href={`mailto:${email}`}>{email}</a>}
          {email && phone && <span className={styles.separator}>|</span>}
          {phone && <a href={`tel:${phone}`}>{phone}</a>}
        </div>
      </div>
    )}

    {buttonLabel && buttonLink && (
      <Button theme="accent-primary" to={buttonLink}>
        {buttonLabel}
      </Button>
    )}
  </div>
);


SuccessMessage.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  supportTitle: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonLink: PropTypes.string,
};

export default SuccessMessage;
